import React from 'react';
import { styled } from 'linaria/react';
import { DesktopNavigation } from './SubPageNavigation';
import { Breadcrumbs } from '../ui/Breadcrumbs';
import { theme } from '../Theme';
import { ContentRenderer } from '@jetshop/ui/ContentRenderer';
import { allContentComponents } from '../ContentEditor/ContentComponents';

const ContentPageWrapper = styled('div')`
  width: 100%;
  max-width: 50rem;
  padding: 0 1rem;
  margin: auto;
  color: ${theme.colors.darkgrey};
  font-family: ${theme.fonts.primaryFontFamily};

  h1 {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  h2 {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1.2rem;
  }
  p + ul {
    margin-top: -0.5rem;
  }
  p + p {
    margin-top: -0.8rem;
  }
  ul {
    margin-bottom: 1.2rem;
  }

  ${theme.below.lg} {
    padding: 0;
  }
`;

const BreadcrumbsWrapper = styled('div')`
  margin: 20px 0px 26px;
  ul {
    margin: 0;
    padding: 0;
  }

  ${theme.below.lg} {
    margin: 10px 16px;
  }
`;

const ContentWrapper = styled('div')`
  margin-top: 26px;
`;

const NavWrapper = styled('div')`
  ${theme.below.lg} {
    padding-left: 1rem;
  }
`;

function ContentPage({ page }) {
  const breadcrumbProps = {
    breadcrumbs: page?.primaryRoute?.breadcrumbs,
    parents: page?.parents
  };

  const items = page?.data?.items;
  return (
    <ContentPageWrapper>
      <BreadcrumbsWrapper>
        <Breadcrumbs {...breadcrumbProps} />
      </BreadcrumbsWrapper>
      <NavWrapper>
        <DesktopNavigation page={page} />
      </NavWrapper>
      <ContentWrapper>
        {items && (
          <ContentRenderer items={items} components={allContentComponents} />
        )}
      </ContentWrapper>
    </ContentPageWrapper>
  );
}

export default ContentPage;
